import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import useCaptchaLoadTracker from './useCaptchaLoadTracker'

const isTestEnvironment = process.env.RAILS_ENV === 'test'

const MTCaptcha = props => {
  const isLoaded = useCaptchaLoadTracker()

  const elementRef = useRef()

  useEffect(() => {
    function loadScripts() { // this is legacy implementation
      const cb = document.createElement('script')
      cb.type = 'text/javascript'
      cb.async = true
      cb.innerHTML = `
      function mt_jsloadedcb()
      {
        window.jsloadedcb = true
        const captchaEvent = new CustomEvent("captchaLoad", {})
        window.dispatchEvent(captchaEvent)
      }
      function mt_renderedcb(state)
      {
        window.renderedcb = true
      }
      function mt_verifiedcb(state)
      {
        window.verifiedcb = state.isVerified
      }
      function mt_verifyexpiredcb(state)
      {
        window.verifiedcb = state.isVerified
      }
      `
      document.body.appendChild(cb)

      const config = {
        'sitekey': 'MTPublic-TJDaU2Yyi',
        'loadAnimation': 'false',
        'render': 'explicit',
        'renderQueue': ['main-captcha', 'navbar-captcha'],
        'autoFormValidate': true,
        'jsloaded-callback': 'mt_jsloadedcb',
        'rendered-callback': 'mt_renderedcb',
        'verified-callback': 'mt_verifiedcb',
        'verifyexpired-callback': 'mt_verifyexpiredcb',
        // Force a visible challenge on abuse-lockout surfaces even when the account
        // has Low Friction Invisible Captcha enabled (mirrors the marketplace
        // checkout gate in app/assets/javascripts/mtcaptcha.js).
        ...(props.forceVisible && { lowFrictionInvisible: 'force-visible' }),
        ...(isTestEnvironment && {
          enableTestMode:
            'MTPrivQA-TJDaU2Yyi-5XjJmmkIrrLnoeZjxGFUPIhVc4KTitzuuexxqxNGkudFWODXTo',
        }),
      }

      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.innerHTML = `
      var mtcaptchaConfig = ${JSON.stringify(config)};
      `
      document.body.appendChild(s)

      const mt_service = document.createElement('script')
      mt_service.src =
        'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js'
      mt_service.async = true
      document.body.appendChild(mt_service)

      const mt_service2 = document.createElement('script')
      mt_service2.src =
        'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js'
      mt_service2.async = true
      document.body.appendChild(mt_service2)
    }

    if (typeof mtcaptcha === 'undefined') {
      loadScripts()
    } else if (props.forceVisible && window.mtcaptchaConfig) {
      // SDK already loaded by another surface without force-visible. The SDK keeps
      // a live reference to window.mtcaptchaConfig and re-merges it on every
      // renderUI call, so mutating the existing object (never replacing it)
      // upgrades subsequent renders on this page to a visible challenge.
      window.mtcaptchaConfig.lowFrictionInvisible = 'force-visible'
    }
  }, [])

  const captchaElement = document.getElementById(props.captchaId)

  if (
    typeof mtcaptcha !== 'undefined' && captchaElement?.innerHTML === ""
  ) {
    const captchaStatus = mtcaptcha.getStatus(props.captchaId)

    if (captchaStatus.statusCode === 2200) {
      mtcaptcha.remove(props.captchaId)
    }

    if (!captchaStatus.isVerified) {
      mtcaptcha.renderUI(props.captchaId)
    }
  }

  return <div id={props.captchaId} className='mtcaptcha' ref={elementRef} />
}

MTCaptcha.propTypes = {
  captchaId: PropTypes.string.isRequired,
  forceVisible: PropTypes.bool,
}

export default MTCaptcha
